// ============================================================================
// Application Version Configuration
// ============================================================================
// Derives version info from changelog.js - do NOT edit version numbers here.
// To release a new version, add an entry to src/shared/data/changelog.js.

import { changelog } from 'shared/data/changelog.js';

const latest = changelog[0];

export const VERSION = {
    number: latest.version.replace('v', ''),
    date: latest.date,
    name: 'AERIUM',
};

/**
 * Get formatted version string
 * @returns {string} e.g., "V0.21"
 */
export function getVersionString() {
    return `V${VERSION.number}`;
}

/**
 * Get recent changelog entries in compact format (used by login page)
 * @param {number} count - Number of entries to return
 * @returns {Array<{version: string, date: string, summary: string}>}
 */
export function getRecentChanges(count = 5) {
    return changelog.slice(0, count).map(entry => ({
        version: entry.version.replace('v', ''),
        date: entry.date,
        summary: entry.description
    }));
}
